/**
 * UA labels for review/specialist badges. Mirrors
 * `backend/apps/reviews/models.py::Badge.KIND_CHOICES` plus forward-looking
 * slugs from the F-160 audit (`top_rated`, `new`, `rising`) so future backend
 * additions don't leak raw slugs into UA UI.
 *
 * If the backend emits an unknown slug, we fall back to the slug itself —
 * better than crashing, still visible during QA.
 */
export const BADGE_LABEL: Record<string, string> = {
  // Currently shipped by backend (apps/reviews/models.py::Badge.KIND_CHOICES)
  maestro: 'Маестро',
  reliable: 'Надійний',
  punctual: 'Пунктуальна',
  fair_price: 'Чесна ціна',
  clean: 'Чистота',
  quick_responder: 'Швидка відповідь',
  verified: 'Верифікована',
  // Reserved / planned (F-160 spec) — keep labels ready
  top_rated: 'Топ-рейтинг',
  new: 'Новий',
  rising: 'Набирає обертів',
};

export function badgeLabel(slug: string): string {
  return BADGE_LABEL[slug] ?? slug;
}
